import Axios from 'axios'

// 获取验证码
export const legalPersonVerCode = (data) => Axios({
    url: '/zuwu-api/web/enterprise/legalPersonVerCode',
    method: 'post',
    data
});
// 添加企业信息
export const addEnterpriseInfo = (data) => Axios({
    url: '/zuwu-api/web/enterprise/addEnterpriseInfo',
    method: 'post',
    data
});
// 企业信息
export const enterpriseInfoDetails = (params) => Axios({
    url: '/zuwu-api/web/enterpriseInfo/details',
    method: 'post',
    params
});
// 身份证
export const idCardOcr = (params) => Axios({
    url: '/zuwu-api/web/enterprise/idCardOcr',
    method: 'post',
    params
});
// 营业执照
export const businessLicenseOcr = (params) => Axios({
    url: '/zuwu-api/web/enterprise/businessLicenseOcr',
    method: 'post',
    params
});

// 根据企业名称查询企业管理员手机号
export const getMobileByEnterpriseName = (params) => Axios({
    url: '/zuwu-api/web/enterprise/getMobileByEnterpriseName',
    method: 'get',
    params
});
// 企业验证发送手机短信验证码
export const enterpriseSmsCaptcha = (params) => Axios({
    url: '/zuwu-api/web/enterprise/smsCaptcha',
    method: 'get',
    params
});
// 绑定企业校验验证码
export const bindingEnterpriseCheck = (params) => Axios({
    url: '/zuwu-api/web/enterprise/bindingEnterpriseCheck',
    method: 'get',
    params
});
// 解绑企业
export const unbindEnterprise = (params) => Axios({
    url: '/zuwu-api/web/enterprise/unbindEnterprise',
    method: 'get',
    params
});